import { ServiceException } from '@inter-ikea-kompis/exceptions';
import ServiceFetch from '../../utilities/ServiceFetch.js';
/**
 * This class is used for fetching store availability data.
 */
export default class DexfWebplannerStoreAvailabilityService {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.endpoint Endpoint.
     * @param options.dexfApiKey DEXF Api key.
     */
    constructor(options) {
        this.endpoint = options.endpoint;
        this.dexfApiKey = options.dexfApiKey;
    }
    /**
     * Fetches availability for a store id and given application.
     *
     * @param storeId Store ID.
     * @param dexfApplicationId Application id set in DEXF.
     * @returns Promise with IStoreAvailability[].
     */
    async getStoreAvailabilities(storeId, dexfApplicationId) {
        const options = {
            credentials: 'same-origin',
            headers: {
                'dexf-api-key': this.dexfApiKey
            }
        };
        const url = `${this.endpoint.replace('{storeId}', encodeURIComponent(storeId.replace(/ /g, '')))}?filter.appId=${dexfApplicationId}`;
        const response = await ServiceFetch.json(url, options);
        if (!response.data) {
            throw new ServiceException('Failed to fetch from DEXF webplanner availability API. No data in response.');
        }
        return this.transformResponse(response);
    }
    /**
     * Transforms the response and returns only valid items.
     *
     * @param response Responses.
     * @param response.data ...
     * @returns Valid IStoreAvailability items.
     */
    transformResponse(response) {
        const result = [];
        for (const item of response.data) {
            if (item.valid && item.content) {
                const storeAvailability = {
                    itemId: item.itemId,
                    content: {
                        itemType: item.content.itemType,
                        itemNo: item.content.itemNo,
                        availableForCashCarry: item.content.availableForCashCarry
                    }
                };
                if (item.content.cashCarry) {
                    storeAvailability.content.cashCarry = {
                        messageType: item.content.cashCarry.messageType,
                        unitType: item.content.cashCarry.unitType,
                        quantity: item.content.cashCarry.quantity,
                        restock: item.content.cashCarry.restock,
                        salesLocations: item.content.cashCarry.salesLocations
                    };
                }
                if (item.content.homeDelivery) {
                    storeAvailability.content.homeDelivery = item.content.homeDelivery;
                }
                result.push(storeAvailability);
            }
        }
        return result;
    }
}
//# sourceMappingURL=DexfWebplannerStoreAvailabilityService.js.map